import apiClient from "../../../utilities/apiClient";

export const get_arnInitialData = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.getArnInitialData}?token=${payload}`,
    "",
    true
  );
};
export const get_arnTokenValid = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.getArnTokenValid}?token=${payload}`,
    "",
    true
  );
};
export const createArn_api = (payload) => {
  return apiClient.post(`${apiClient.Urls.createArn}`, payload, true, "file");
};
